import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { SundaySchedule } from './shared/SundaySchedule';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBook, faList } from '@fortawesome/free-solid-svg-icons';

import './Announcement.css';

export default function Home (){
  return <div className="container container-fix">
    <h1>Lake Forest Ward</h1>
    <p>
      Welcome to the Lake Forest Ward events app.
    </p>
    <hr />
    <h3>Ward Sacrament Meeting Program</h3>
      <LinkContainer to={'/program'}>
            <Button size="large" variant='secondary'>
              <FontAwesomeIcon icon={faBook} />
              &nbsp; Sacrament Meeting Program
            </Button>
        </LinkContainer>
    <hr />
    <h2>Announcements</h2>
    <p>
      Announcements change often so check back regularly for updates.
    </p>
      <LinkContainer to={'/announcements'}>
            <Button size="large" variant='secondary'>
              <FontAwesomeIcon icon={faList} />
              &nbsp; Announcements List
            </Button>
        </LinkContainer>
    <hr />
    <SundaySchedule /> 

    {/* <BuildingCleaning /> */}
    <br />
    <br />
  </div>
}
